import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "op-screen mx-auto flex max-w-3xl flex-col gap-10 px-6 pt-4 pb-12" };
const _hoisted_2 = {
    key: 1,
    class: "text-sm text-(--colors-text-body-subtle)"
};
const _hoisted_3 = { class: "flex flex-col gap-px" };
const _hoisted_4 = { class: "text-[28px] font-bold leading-[34px] text-(--colors-text-black-default)" };
const _hoisted_5 = { class: "text-base leading-6 text-(--colors-text-body-subtle)" };
const _hoisted_6 = { class: "font-bold" };
const _hoisted_7 = { class: "flex flex-col gap-6" };
const _hoisted_8 = { class: "text-[22px] font-bold leading-[26px] text-(--colors-text-black-default)" };
const _hoisted_9 = { class: "flex flex-col gap-3" };
const _hoisted_10 = ["onClick"];
const _hoisted_11 = { class: "flex min-w-0 flex-1 flex-col gap-0.5" };
const _hoisted_12 = { class: "truncate text-sm font-medium leading-5 text-(--colors-text-heading)" };
const _hoisted_13 = {
    key: 0,
    class: "truncate text-sm font-normal leading-5 text-(--colors-text-body-subtle)"
};
const _hoisted_14 = {
    key: 0,
    class: "text-sm text-(--colors-text-body-subtle)"
};
const _hoisted_15 = { class: "flex flex-wrap items-center justify-end gap-3" };
import { onMounted } from "vue";
import { Checkbox, Button, Alert } from "@eudonet/opal";
import { useEmailPreferences } from "@/modules/consent/composables/useEmailPreferences";
export default /*@__PURE__*/ _defineComponent({
    __name: 'EmailPreferencesView',
    props: {
        token: {}
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const { state, data, purposes, isBusy, subscribedNewsletter, groups, purposeLabel, purposeDescription, toggleRow, load, save, unsubscribeAll, } = useEmailPreferences(props.token);
        onMounted(() => load());
        __expose({ save, unsubscribeAll, load });
        return (_ctx, _cache) => {
            const _component_i18n_t = _resolveComponent("i18n-t");
            return (_openBlock(), _createElementBlock("main", _hoisted_1, [
                (_unref(state) === 'expired')
                    ? (_openBlock(), _createBlock(_unref(Alert), {
                        key: 0,
                        color: "info",
                        heading: _ctx.$t('emailPreferences.expired'),
                        message: _ctx.$t('emailPreferences.expiredHint')
                    }, null, 8 /* PROPS */, ["heading", "message"]))
                    : (_unref(state) === 'loading')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t("common.loading")), 1 /* TEXT */))
                        : (_unref(state) === 'error')
                            ? (_openBlock(), _createBlock(_unref(Alert), {
                                key: 2,
                                color: "danger",
                                heading: _ctx.$t('emailPreferences.error'),
                                message: _ctx.$t('emailPreferences.errorHint')
                            }, null, 8 /* PROPS */, ["heading", "message"]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _createElementVNode("header", _hoisted_3, [
                                    _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("emailPreferences.title")), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_5, [
                                        (_unref(subscribedNewsletter))
                                            ? (_openBlock(), _createBlock(_component_i18n_t, {
                                                key: 0,
                                                keypath: "emailPreferences.subscribedTo",
                                                tag: "p",
                                                scope: "global"
                                            }, {
                                                newsletter: _withCtx(() => [
                                                    _createElementVNode("strong", _hoisted_6, _toDisplayString(_unref(subscribedNewsletter)), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                            }))
                                            : _createCommentVNode("v-if", true),
                                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("emailPreferences.intro", { email: _unref(data)?.email })), 1 /* TEXT */)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_7, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groups), (group) => {
                                        return (_openBlock(), _createElementBlock("section", {
                                            key: group.channel,
                                            class: "flex flex-col gap-2"
                                        }, [
                                            _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t(`emailPreferences.channel.${group.channel}`)), 1 /* TEXT */),
                                            _createElementVNode("div", _hoisted_9, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (p) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: p.purpose,
                                                        class: _normalizeClass(["flex items-center gap-2 rounded-xl border border-(--colors-border-base-medium) bg-(--colors-background-white) p-4", _unref(isBusy) ? 'cursor-not-allowed opacity-60' : 'cursor-pointer']),
                                                        onClick: ($event) => (_unref(toggleRow)(p))
                                                    }, [
                                                        _createVNode(_unref(Checkbox), {
                                                            modelValue: p.checked,
                                                            "onUpdate:modelValue": ($event) => ((p.checked) = $event),
                                                            disabled: _unref(isBusy),
                                                            "aria-label": _unref(purposeLabel)(p),
                                                            class: "w-fit! shrink-0"
                                                        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "disabled", "aria-label"]),
                                                        _createElementVNode("div", _hoisted_11, [
                                                            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(purposeLabel)(p)), 1 /* TEXT */),
                                                            (_unref(purposeDescription)(p))
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(purposeDescription)(p)), 1 /* TEXT */))
                                                                : _createCommentVNode("v-if", true)
                                                        ])
                                                    ], 10 /* CLASS, PROPS */, _hoisted_10));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ])
                                        ]));
                                    }), 128 /* KEYED_FRAGMENT */)),
                                    (_unref(purposes).length === 0)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t("emailPreferences.empty")), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                    _createVNode(_unref(Button), {
                                        variant: "secondary",
                                        label: _ctx.$t('emailPreferences.unsubscribeAll'),
                                        loading: _unref(state) === 'unsubscribing',
                                        disabled: _unref(state) === 'saving',
                                        onClick: _unref(unsubscribeAll)
                                    }, null, 8 /* PROPS */, ["label", "loading", "disabled", "onClick"]),
                                    _createVNode(_unref(Button), {
                                        variant: "primary",
                                        label: _ctx.$t('emailPreferences.save'),
                                        loading: _unref(state) === 'saving',
                                        disabled: _unref(state) === 'unsubscribing',
                                        onClick: _unref(save)
                                    }, null, 8 /* PROPS */, ["label", "loading", "disabled", "onClick"])
                                ])
                            ], 64 /* STABLE_FRAGMENT */))
            ]));
        };
    }
});
